/** Anzeige-Texte. Kein Rechnen mit Lernständen — das macht ausschließlich der Server. */

const MS_PRO_TAG = 86_400_000

function komma(wert, stellen = 1) {
  return wert.toFixed(stellen).replace('.', ',')
}

/**
 * Intervall auf den Bewertungsknöpfen. Bis 30 Tage in Tagen, danach Monate,
 * ab einem Jahr Jahre — sonst stünde auf dem Knopf „120 Tage" statt „3,9 Mon.".
 */
export function intervallText(tage) {
  const t = Math.max(1, Math.round(Number(tage) || 0))
  if (t === 1) return '1 Tag'
  if (t <= 30) return `${t} Tage`
  if (t < 365) return `${komma(t / 30.44)} Mon.`
  return `${komma(t / 365.25)} J.`
}

export function datumText(iso) {
  if (!iso) return '—'
  const [j, m, t] = String(iso).slice(0, 10).split('-')
  return `${t}.${m}.${j}`
}

/**
 * Der heutige Tag als "YYYY-MM-DD" in Ortszeit — bewusst nicht über
 * `toISOString()`, das rechnet nach UTC und läge abends in Berlin einen Tag
 * daneben. Wird beim Rendern gerufen, nicht beim Laden des Moduls: eine tagelang
 * offene PWA hätte sonst für immer den Tag ihres Starts.
 */
export function heuteIso(jetzt = new Date()) {
  const zweistellig = (n) => String(n).padStart(2, '0')
  return `${jetzt.getFullYear()}-${zweistellig(jetzt.getMonth() + 1)}-${zweistellig(jetzt.getDate())}`
}

/** Abstand zum heutigen Tag in Worten, für Themenliste und Kartenliste. */
export function faelligText(iso, heuteIso) {
  if (!iso) return 'neu'
  const tage = Math.round(
    (Date.parse(`${iso}T00:00:00Z`) - Date.parse(`${heuteIso}T00:00:00Z`)) / MS_PRO_TAG,
  )
  if (tage < 0) return 'überfällig'
  if (tage === 0) return 'heute'
  if (tage === 1) return 'morgen'
  return `in ${tage} Tagen`
}

export function zahl(wert) {
  return new Intl.NumberFormat('de-DE').format(Number(wert) || 0)
}
